import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_LOCATIONS);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_LOCATIONS_UPLOAD_TEMPLATE);


const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters = {
    getData: (state) => {
        if (state.data) {
            return state.data
        } else {
            this.fetchAll()
        }
    },
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    }
}
const mutations = {
    set: (state, [payload, le_id]) => {
        state.data[le_id] = payload
        state.data = {...state.data };
    },

    addEntity: (state, [payload, id]) => {
        if (!state.data[id]) {
            state.data[id] = [...payload]
        } else {
            state.data[id].push(payload);
            state.data[id] = [...state.data[id]];
        }
    },

    updateEntityById: (state, [payload, le_index]) => {
        for (let i = 0; i < state.data[le_index].length; i++) {
            if (state.data[le_index][i][_pk_name] === payload.id) {
                state.data[le_index].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [id, le_index]) => {
        for (let i = 0; i < state.data[le_index].length; i++) {
            if (state.data[le_index][i][_pk_name] == id) {
                state.data[le_index].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, le_index) {

        try {
            commit("setFetching", true);
            let res = await axios_instance.get('/', {
                params: { le_id: le_index }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                if (res.data) {
                    commit("set", [res.data.payload.data, le_index]); //todo: Check for Pagination
                }
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async uploadTemplate({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("addEntity", [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, [payload, le_index]) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", [res.data, le_index]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, le_index]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, le_index]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}